<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img
                    class="img-fluid logo-mv"
                    src="../assets/images/logo/mexico_verde2.png"
                    alt="Portal México Verde"
                  />
                </a>
              </div>
              <div class="login-main">

                <form class="theme-form" @submit.prevent="submitForm">
                  <h6 class="text-center text-muted mb-3">Solicita una cuenta</h6>
                  <p>Ingresa tus datos y los de tu empresa</p>

                  <!-- Nombre y Apellido -->
                  <div class="form-group">
                    <label class="col-form-label pt-0">Nombres y Apellidos</label>
                    <div class="row g-2">
                      <div class="col-6">
                        <input
                          class="form-control"
                          :class="{ 'is-invalid': errores.first_name }"
                          type="text"
                          v-model="form.first_name"
                          placeholder="Nombres"
                          required
                        />
                        <div v-if="errores.first_name" class="invalid-feedback">
                          {{ campoError('first_name') }}
                        </div>
                      </div>
                      <div class="col-6">
                        <input
                          class="form-control"
                          :class="{ 'is-invalid': errores.last_name }"
                          type="text"
                          v-model="form.last_name"
                          placeholder="Apellidos"
                          required
                        />
                        <div v-if="errores.last_name" class="invalid-feedback">
                          {{ campoError('last_name') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Email -->
                  <div class="form-group">
                    <label class="col-form-label">Correo Electrónico</label>
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': errores.email }"
                      type="email"
                      v-model="form.email"
                      placeholder="correo@empresa.com"
                      required
                    />
                    <div v-if="errores.email" class="invalid-feedback">
                      {{ campoError('email') }}
                    </div>
                  </div>

                  <!-- Contraseña -->
                  <div class="form-group">
                    <label class="col-form-label">Contraseña</label>
                    <div class="form-input position-relative">
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': errores.password }"
                        :type="active ? 'password' : 'text'"
                        v-model="form.password"
                        placeholder="*********"
                        required
                      />
                      <div class="show-hide">
                        <span :class="active ? 'show' : 'hide'" @click.prevent="show"></span>
                      </div>
                    </div>
                    <div v-if="errores.password" class="text-danger small mt-1">
                      {{ campoError('password') }}
                    </div>
                  </div>

                  <!-- Empresa -->
                  <div class="form-group">
                    <label class="col-form-label">Empresa</label>
                    <input
                      class="form-control"
                      :class="{ 'is-invalid': errores.empresa }"
                      type="text"
                      v-model="form.empresa"
                      placeholder="Nombre comercial o razón social"
                      required
                    />
                    <div v-if="errores.empresa" class="invalid-feedback">
                      {{ campoError('empresa') }}
                    </div>
                  </div>

                  <!-- Error general -->
                  <div v-if="errorGeneral" class="alert alert-danger py-2 small">
                    {{ errorGeneral }}
                  </div>

                  <div class="form-group mb-0">
                    <div class="checkbox p-0 mb-3">
                      <input id="checkbox1" type="checkbox" v-model="privacidad" required />
                      <label class="text-muted" for="checkbox1">
                        Acepto la<a class="ms-2" href="#">Política de Privacidad</a>
                      </label>
                    </div>
                    <button
                      class="btn btn-primary btn-block"
                      type="submit"
                      :disabled="enviando"
                    >
                      <span
                        v-if="enviando"
                        class="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                      {{ enviando ? 'Registrando…' : 'Crear cuenta' }}
                    </button>
                  </div>

                  <p class="mt-4 mb-0">
                    ¿Ya tienes una cuenta?
                    <router-link class="ms-2" to="/auth/login">Iniciar sesión</router-link>
                  </p>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/axios";
import authService from "@/services/authService";

export default {
  data() {
    return {
      form: {
        first_name: "",
        last_name:  "",
        email:      "",
        password:   "",
        empresa:    "",
      },
      privacidad:   false,
      active:       true,
      enviando:     false,
      errores:      {},
      errorGeneral: null,
    };
  },

  methods: {
    show() {
      this.active = !this.active;
    },

    campoError(campo) {
      const val = this.errores[campo];
      if (!val) return "";
      return Array.isArray(val) ? val[0] : val;
    },

    async submitForm() {
      this.errores      = {};
      this.errorGeneral = null;
      this.enviando     = true;
      try {
        const { data } = await api.post("registro/", { ...this.form });
        authService.saveSession(data.access, data.refresh);
        authService.setUserData(data.user);
        this.$router.push("/app/bienvenida");
      } catch (err) {
        if (err.response?.status === 400 && err.response.data?.errores) {
          this.errores = err.response.data.errores;
        } else {
          this.errorGeneral =
            err.response?.data?.detail ?? "Error al crear la cuenta. Intenta de nuevo.";
        }
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
.logo-mv {
  width: 180px;
  height: auto;
  display: block;
  margin: 0 auto 0.5rem;
}
.btn-primary {
  background-color: #09377c !important;
  border-color: #09377c !important;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #0a1e36 !important;
  border-color: #0a1e36 !important;
}
</style>
